import { BaseSnapshotModel } from "../BaseSnapshotModel";

export class HighBloodSugarSnapshotModel extends BaseSnapshotModel {
  constructor() {
    super();
    this.Model = {
      modelFields: ["high_blood_sugar"],

      requiredFields: []
    };
  }
}
